<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="top_box flex Flexjustify Flexalign">
      <div class="top_content flex FlexBetween">
        <div class="top_content_left flex Flexalign">
          <el-image class="user_avatar" :src="iconPath(userInfo.headImage)"></el-image>
          <div class="personal_info flex flexcolumn FlexBetween">
            <div class="flex Flexalign">
              <div class="personal_name">{{ userInfo.name }}</div>
              <!-- <el-image class="member_logo" :src="iconPath('member_logo.png')"></el-image>
              <div class="personal_memberDate">
                会员有效期至：{{ personalInfo.memberDate }}
              </div> -->
            </div>
            <!-- <div class="follow_num">关注 {{ userInfo.collectCount || 0 }} 人</div> -->
            <div class="personal_signature">
              {{
                userInfo.personalSign
                  ? userInfo.personalSign
                  : "这个人很懒没有设置签名～"
              }}
            </div>
          </div>
        </div>
        <div class="top_content_right flex FlexEvenly Flexalign">
          <div class="flex flexcolumn reply_box Flexalign Flexjustify">
            <div class="reply_text">回复</div>
            <div class="reply_num">{{ totalReply || 0 }}</div>
          </div>
          <div class="flex flexcolumn reply_box Flexalign Flexjustify">
            <div class="reply_text">获赞</div>
            <div class="reply_num">{{ totalGiveup || 0 }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="top_box top_menu_list flex Flexjustify Flexalign">
      <div class="top_content flex Flexalign">
        <div class="menu_one cursor_pointer" v-for="(item, index) in topMenuList" :key="index"
          :class="{ active_menu: item.value == topSelectMenu }" @click="changeTopMenu(item)">
          {{ item.label }}
        </div>
      </div>
    </div> -->
    <div class="content_box flex Flexjustify Flexalign">
      <div class="content flex FlexBetween">
        <div>
          <div class="flex">
            <div class="tab_list px-12 py-20">
              <div class="tab_title">个人中心</div>
              <div v-for="(item, index) in topMenuList" :key="index">
                <div class="tab_one flex Flexalign mt-20 cursor_pointer" @click="changeTopMenu(item)">
                  <el-image class="learningCenter_tab_icon1"
                    :src="iconPath(item.value == topSelectMenu ? item.activeIcon : item.icon)"></el-image>
                  <div class="ml-10" :class="{ active_menu: item.value == topSelectMenu }">{{ item.label }}</div>
                </div>
              </div>
            </div>
            <div class="content_left ml-20">
              <div class="lecturer_info" v-if="topSelectMenu == 1 || topSelectMenu == 2">
                <div class="menu_list flex">
                  <div class="menu_one flex flexcolumn Flexalign cursor_pointer" v-for="(item, index) in menuList"
                    :key="index" @click="chaneMenu(item)" :class="[item.value == selectMenu ? 'active_menu' : '']">
                    {{ item.label }}
                    <!-- <div :class="[item.value == selectMenu ? 'line_active' : '']"></div> -->
                  </div>
                </div>
                <div>
                  <theme v-if="selectMenu == 1 && topSelectMenu == 2" ref="myLikedTheme" @changeTab="changeTab"></theme>
                  <reply v-if="selectMenu == 2 && topSelectMenu == 2" ref="reply" @changeTab="changeTab"></reply>
                  <evaluate v-if="selectMenu == 3 && topSelectMenu == 2" ref="likedEvaluate" @changeTab="changeTab">
                  </evaluate>
                  <releaseReply v-if="selectMenu == 2 && topSelectMenu == 1" ref="releaseReply" @changeTab="changeTab">
                  </releaseReply>
                  <evaluate v-if="selectMenu == 3 && topSelectMenu == 1" :showDelete="true" ref="evaluate"
                    @changeTab="changeTab"></evaluate>
                  <theme v-if="selectMenu == 1 && topSelectMenu == 1" :showDelete="true" ref="myTheme"
                    @changeTab="changeTab"></theme>
                </div>
                <div class="pagination_box mar_top_20 flex FlexjustifyEnd"
                  v-if="listTotal && listTotal > listQuery.pageSize">
                  <el-pagination background layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40]"
                    :total="listTotal" v-model:page-size="listQuery.pageSize" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" />
                </div>
              </div>
              <!-- 收藏 -->
              <div class="lecturer_info" v-else-if="topSelectMenu == 3">
                <collectList :resizeImg="true"></collectList>
              </div>
              <!-- 家庭关系 -->
              <div class="lecturer_info" v-else-if="topSelectMenu == 0">
                <familyGroup></familyGroup>
              </div>
              <!-- 我的提问 -->
              <div class="lecturer_info" v-else-if="topSelectMenu == 4">
                <myQuestion></myQuestion>
              </div>
              <!-- 伴学师 -->
              <div class="lecturer_info" v-else-if="topSelectMenu == 5">
                <companionTeacher></companionTeacher>
              </div>
              <!-- 试卷 -->
               <div class="lecturer_info" v-else-if="topSelectMenu == 6">
                <examPaperList></examPaperList>
              </div>
            </div>
          </div>
          <div class="course_list_box1">
            <div class="course_list_box">
              <div class="flex FlexBetween">
                <div class="recommend">推荐课程</div>
                <div class="more_btn flex Flexalign Flexjustify">
                  更多
                  <div class="flex Flexalign" style="margin-left: 5px">
                    <el-icon :size="18">
                      <ArrowRight color="rgba(102, 102, 102, 1)" />
                    </el-icon>
                  </div>
                </div>
              </div>
              <courseList></courseList>
            </div>
          </div>
        </div>
        <div class="content_right">
          <div class="top_banner_right flex flexcolumn">
            <signIn></signIn>
          </div>
          <recommendCourseList></recommendCourseList>
        </div>
      </div>
    </div>

  </moe-page>
</template>
<script>
import courseList from "@/views/course/components/courseList.vue";
import collectList from "./components/collectList.vue";
import theme from "./components/theme.vue";
import reply from "./components/reply.vue";
import evaluate from "./components/evaluate.vue";
import releaseReply from "./components/releaseReply.vue";
import signIn from "@/components/integral/signIn.vue";
import recommendCourseList from "@/views/course/components/recommendCourseList.vue";
import familyGroup from "./components/familyGroup.vue";
import myQuestion from "./components/myQuestion.vue";
import companionTeacher from "./components/companionTeacher.vue";
import examPaperList from "./components/examPaperList.vue";
import { mapState } from "vuex";
export default {
  name: "GjkcH5Index",
  components: {
    courseList,
    theme,
    reply,
    evaluate,
    releaseReply,
    collectList,
    signIn,
    recommendCourseList,
    familyGroup, myQuestion, companionTeacher,examPaperList
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  data() {
    return {
      personalInfo: {
        avatar: "user_avatar.png",
        name: "小杨同学",
        isMember: true,
        memberDate: "2025-01-19",
        followNum: 10,
        signature: "",
      },
      menuList: [
        { label: "主题", value: 1 },
        { label: "回复", value: 2 },
        { label: "评价", value: 3 },
      ],
      selectMenu: 1,
      topMenuList: [
        { label: "我的家庭", value: 0, icon: 'learningCenter_tab_icon1.png', activeIcon: 'learningCenter_tab_icon1_active.png' },
        { label: "我发布的", value: 1, icon: 'learningCenter_tab_icon2.png', activeIcon: 'learningCenter_tab_icon2_active.png' },
        { label: "我的提问", value: 4, icon: 'learningCenter_tab_icon5.png', activeIcon: 'learningCenter_tab_icon5_active.png' },
        { label: "我的点赞", value: 2, icon: 'learningCenter_tab_icon3.png', activeIcon: 'learningCenter_tab_icon3_active.png' },
        { label: "我的收藏", value: 3, icon: 'learningCenter_tab_icon4.png', activeIcon: 'learningCenter_tab_icon4_active.png' },
        { label: "我的试卷", value: 6, icon: 'learningCenter_tab_icon7.png', activeIcon: 'learningCenter_tab_icon7_active.png' },
        { label: "我的伴学师", value: 5, icon: 'learningCenter_tab_icon6.png', activeIcon: 'learningCenter_tab_icon6_active.png' },
      ],
      topSelectMenu: 0,
      totalReply: "",
      totalGiveup: "",
      listQuery: {
        page: 1,
        pageSize: 10,
        orderByColumn: "",
        isAsc: "",
      },
      listTotal: 0,
    };
  },

  mounted() {
    let selectMenu = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).selectMenu;
    if (selectMenu) {
      this.changeTopMenu({ value: selectMenu })
    }
    this.getReplyCount();
    this.getMyDiscussList();
  },

  methods: {
    handleSizeChange() {
      this.changeTab();
    },
    handleCurrentChange(value) {
      this.listQuery.page = value;
      this.changeTab();
    },
    // tab切换/分页时调用接口
    changeTab() {
      // 我的发布（主题）
      if (this.selectMenu == 1 && this.topSelectMenu == 1) {
        this.getMyDiscussList();
      } else if (this.selectMenu == 2 && this.topSelectMenu == 1) {
        // 我的发布（回复）
        this.listQuery.sceneDetailsReFlag = 1;
        this.getMyReplyList();
      } else if (this.selectMenu == 3 && this.topSelectMenu == 1) {
        // 我的发布（评价）
        this.getEvaluationList();
      } else if (this.selectMenu == 1 && this.topSelectMenu == 2) {
        // 我的点赞（主题）
        this.getMyLikedList();
      } else if (this.selectMenu == 2 && this.topSelectMenu == 2) {
        // 我的点赞（回复）
        this.listQuery.sceneDetailsReFlag = 1;
        this.getMyLikedReply();
      } else if (this.selectMenu == 3 && this.topSelectMenu == 2) {
        // 我的点赞（评价）
        this.getMyLiedEvaluateList();
      }
    },
    chaneMenu(info) {
      this.selectMenu = info.value;
      this.listQuery.page = 1;
      this.changeTab();
    },
    changeTopMenu(info) {
      this.topSelectMenu = info.value;
      this.listQuery.page = 1;
      this.changeTab();
    },
    // 获取回复&获赞数
    getReplyCount() {
      this.$Api.user
        .getReplyCount()
        .then((res) => {
          this.totalReply = res.data.data.replyNum;
          this.totalGiveup = res.data.data.receivedLikeNum;
        })
        .catch(() => { });
    },
    // 获取我发布的主题
    getMyDiscussList() {
      this.$Api.user
        .getMyDiscussList(this.listQuery)
        .then((res) => {
          res.data.data.list.forEach((item) => {
            // let questionImg = item.content.split("url:");
            // if (questionImg.length > 1) {
            //   item.questionImg = questionImg[1].split(";");
            //   let length = item?.questionImg.length;
            //   if (item.questionImg[length - 1] == "") {
            //     item.questionImg.pop();
            //   }
            // }
            // 修改了逻辑，之前在视频下发表主题是通过拼接的方式实现图文，现换成imgs和content，此处处理是为了兼容之前发布的主题
            if (this.$Tools.empty(item.imgs)) {
              let questionImg = item.content.split("url:");
              if (questionImg.length > 1) {
                item.questionImg = questionImg[1].split(";");
                let length = item?.questionImg.length;
                if (item.questionImg[length - 1] == "") {
                  item.questionImg.pop();
                }
              }
            } else {
              item.questionImg = item.imgs.split(",");
            }
          });
          this.$refs.myTheme.themeList = res.data.data.list;
          this.checkIsLike(this.$refs.myTheme.themeList, 2, 'discussId');
          // this.$refs.myTheme.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
          this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
        })
        .catch(() => { });
    },
    // 获取我点赞的主题列表
    getMyLikedList() {
      this.$Api.user
        .getMyLikedList(this.listQuery)
        .then((res) => {
          res.data.data.list.forEach((item) => {
            let questionImg = item.content.split("url:");
            if (questionImg.length > 1) {
              item.questionImg = questionImg[1].split(";");
              let length = item?.questionImg.length;
              if (item.questionImg[length - 1] == "") {
                item.questionImg.pop();
              }
            }
          });
          this.$refs.myLikedTheme.themeList = res.data.data.list;
          this.checkIsLike(this.$refs.myLikedTheme.themeList, 2, 'discussId');
          // this.$refs.myLikedTheme.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
          this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
        })
        .catch(() => { });
    },
    // 获取我发布的（回复列表）
    getMyReplyList() {
      this.$Api.user
        .getMyReplyList(this.listQuery)
        .then((res) => {
          res.data.data.list.forEach((item) => {
            let questionImg = item.content.split("url:");
            if (questionImg.length > 1) {
              item.questionImg = questionImg[1].split(";");
              let length = item?.questionImg.length;
              if (item.questionImg[length - 1] == "") {
                item.questionImg.pop();
              }
            }
          });
          this.$refs.releaseReply.themeList = res.data.data.list;
          this.checkIsLike(this.$refs.releaseReply.themeList, 3, 'replyId');
          // this.$refs.releaseReply.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
          this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
        })
        .catch(() => { });
    },
    // 获取我发布的（评价列表）
    getEvaluationList() {
      this.$Api.user
        .getEvaluationList(this.listQuery)
        .then((res) => {
          res.data.data.list.forEach((item) => {
            item.rate = this.$Tools.scoreToStar(item.score);
          });
          this.$refs.evaluate.themeList = res.data.data.list;
          this.checkIsLike(this.$refs.evaluate.themeList, 1, 'appraiseId');
          // this.$refs.evaluate.listTotal = res.data.data.total?Number(res.data.data.total):0;
          this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
        })
        .catch(() => { });
    },
    // 获取我点赞的（回复列表）
    getMyLikedReply() {
      this.$Api.user
        .getMyLikedReply(this.listQuery)
        .then((res) => {
          res.data.data.list.forEach((item) => {
            item.rate = this.$Tools.scoreToStar(item.score);
          });
          this.$refs.reply.themeList = res.data.data.list;
          this.checkIsLike(this.$refs.reply.themeList, 3, 'replyId');
          // this.$refs.reply.listTotal = res.data.data.total?Number(res.data.data.total):0;
          this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
        })
        .catch(() => { });
    },
    // 获取我点赞的（评价列表）
    getMyLiedEvaluateList() {
      this.$Api.user
        .getMyLiedEvaluateList(this.listQuery)
        .then((res) => {
          res.data.data.list.forEach((item) => {
            item.rate = this.$Tools.scoreToStar(item.score);
          });
          this.$refs.likedEvaluate.themeList = res.data.data.list;
          this.checkIsLike(this.$refs.likedEvaluate.themeList, 1, 'appraiseId');
          // this.$refs.myTheme.listTotal = res.data.data.total?Number(res.data.data.total):0;
          this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
        })
        .catch(() => { });
    },

    // 判断是否点赞
    checkIsLike(list, scene, key) {
      let listQuery = {
        scene: scene,   // 分场景
        sceneIds: "",
      };
      list.forEach((item) => {
        listQuery.sceneIds += item[key] + ",";
      });
      if (!listQuery.sceneIds) return;
      this.$Api.course
        .checkIsLike(listQuery)
        .then((res) => {
          list.forEach((item) => {
            let currentIndex = res.data.data.findIndex(
              (sitem) => sitem == item[key]
            );
            if (currentIndex != -1) {
              item.isLiked = true;
            } else {
              item.isLiked = false;
            }
          });
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang="scss" scoped>
.mar_top_20 {
  margin-top: 20px;
}

.mar_left_15 {
  margin-left: 15px;
}

.mar_left_20 {
  margin-left: 20px;
}

.mar_left_40 {
  margin-left: 40px;
}

.top_box {
  width: 100%;
  height: 140px;
  box-sizing: border-box;
  background: RGBA(40, 42, 53, 1);

  .top_content {
    width: $pageMainWidth;

    .top_content_left {
      .user_avatar {
        width: 70px;
        height: 70px;
        border-radius: 50%;
      }

      .personal_info {
        margin-left: 10px;
        height: 70px;
        color: #ffffff;

        .personal_name {
          font-weight: bold;
          font-size: 20px;
        }

        .member_logo {
          margin-left: 10px;
          width: 72px;
          height: 28px;
        }

        .personal_memberDate {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.7);
          margin-left: 10px;
        }

        .follow_num {
          color: rgba(255, 255, 255, 0.9);
        }

        .personal_signature {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.7);
        }
      }
    }

    .top_content_right {
      width: 224px;
      height: 80px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 17px;

      .reply_box {
        height: 80px;
      }

      .reply_text {
        color: rgba(255, 255, 255, 0.8);
      }

      .reply_num {
        margin-top: 6px;
        font-size: 20px;
        font-weight: 600;
        color: #ffffff;
      }
    }
  }
}

.top_menu_list {
  height: 64px;
  background: #ffffff;

  .menu_one {
    font-size: 18px;
    // 
    color: #999999;
    margin-right: 30px;
  }

  .active_menu {
    color: #13d6aa;
    font-weight: 600;
  }
}

.active_menu {
  color: #13d6aa;
  font-weight: 600;
}

.content_box {
  padding-top: 15px;
  width: 100%;
  background: #f3f3f3;

  .content {
    width: $pageMainWidth;

    .tab_list {
      width: 160px;
      height: 380px;
      background: #FFFFFF;
      border-radius: 10px;
      box-sizing: border-box;

      .tab_title {
        color: #303030;
      }

      .tab_one {
        .learningCenter_tab_icon1 {
          width: 26px;
          height: 26px;
        }
      }
    }

    .content_left {
      flex: 1;

      .institution_info {
        width: 100%;
        height: 106px;
        background: #ffffff;
        border-radius: 10px;
        padding: 15px 20px;
        box-sizing: border-box;

        .institution_info_left {
          .avatar_img {
            width: 77px;
            height: 77px;
            border-radius: 50%;
          }

          .insitution_content {
            margin-left: 20px;
          }

          .institution_name {
            font-weight: 600;
            font-size: 20px;
            color: #333333;
          }

          .institution {
            margin-left: 15px;
            width: 100px;
            height: 28px;
          }

          .institution_desc {
            margin-top: 10px;
            color: #999999;
          }
        }

        .btn_follow {
          width: 94px;
          height: 36px;
          background: linear-gradient(90deg, #00d5c2, #00d498);
          border-radius: 18px;
          color: #ffffff;

          .collect_icon {
            width: 24px;
            height: 24px;
            margin-right: 7px;
          }
        }
      }

      .lecturer_info {
        width: 100%;
        background: #ffffff;
        border-radius: 10px;
        padding: 15px 20px;
        box-sizing: border-box;

        .menu_list {
          // border-bottom: 1px solid rgba(20, 20, 20, 0.1);

          .menu_one {
            line-height: 50px;
            margin: 0 10px;
            position: relative;
            color: rgba(153, 153, 153, 1);
          }

          .active_menu {
            color: #13d6aa;
            font-weight: 600;
          }

          .line_active {
            position: absolute;
            bottom: 0;
            width: 50px;
            height: 2px;
            background: #13d6aa;
          }
        }
      }

      .advertisement_box {
        margin-bottom: 40px;
        width: 100%;
        box-sizing: border-box;
        padding: 20px;
        background: #ffffff;
        border-radius: 10px;

        // .advertisement_one{
        //     width: 45%;
        // }
        .advertisement_img {
          width: 390px;
          height: 150px;
        }
      }
    }

    .content_right {
      margin-left: 20px;
      width: calc($pageMainWidth - 868px);

      .top_banner_right {
        width: 100%;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 1);
        border-radius: 10px;
        // padding: 12px;
        // height: 530px;
        margin-bottom: 10px;
      }

      .course_list {
        margin-top: 10px;
        width: 100%;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 1);
        border-radius: 10px;
        padding: 12px;

        .recommend {
          font-weight: bold;
          font-size: 18px;
          color: #111111;
        }

        .more_btn {
          color: rgba(102, 102, 102, 1);
        }

        .course_one {
          background: #ffffff;
          border-radius: 10px;
          width: 100%;
          margin-top: 15px;

          .course_title {
            font-weight: bold;
            font-size: 18px;
            color: #111111;
          }

          .course_rank_list {
            .course_one_img {
              width: 100px;
              height: 70px;
            }

            .course_info {
              height: 70px;
              margin-left: 11px;

              .course_rate {
                :deep(.el-rate .el-rate__icon) {
                  margin-right: 0;
                }

                .course_price {
                  color: #ff6619;
                  font-size: 18px;
                  font-weight: 600;

                  .course_price_unit {
                    font-size: 16px;
                    font-weight: 400;
                  }
                }
              }

              .course_online_info {
                .course_online {
                  font-size: 14px;
                  color: #999999;
                }
              }
            }
          }
        }
      }
    }
  }
}

.course_list_box1 {
  background: #f3f3f3;
  // width: $pageMainWidth;
  padding: 0 calc((100% - $pageMainWidth)/2);
}

.course_list_box {
  margin: 20px 0;
  width: 850px;
  box-sizing: border-box;
  padding: 20px;
  background: #ffffff;
  border-radius: 10px;

  .recommend {
    font-weight: bold;
    font-size: 18px;
    color: #111111;
  }

  .more_btn {
    color: rgba(102, 102, 102, 1);
  }
}

.pagination_box {
  width: 100%;
}
</style>
